import {FC} from "react";
import "@styles/form.css"

interface IImageWithFade {
  url: string
}

export const ImageWithFade: FC<IImageWithFade> = ({...props}) => (
    <div style={{position: "relative"}}>
      <div className={'overlay-div'}>Edit</div>
      <img src={props.url} alt={"alt"}/>
    </div>
  );

export default ImageWithFade;
